import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
    epiBlockData: {},
    page: '',
    messageType: '',
    selectedSubscriber: {},
    router: {}
};

const speedTestAndDisconnectionsWizardBlockSlice = createSlice({
  name: 'speedTestAndDisconnectionsWizardBlock',
  initialState: initialState,

  reducers: {
    resetBlock: (state) => initialState,
    initBlock: {
        reducer: (state, action) => {
            state.epiBlockData = action.payload.epiBlockData;
            state.page = action.payload.page;
        },
        prepare: (action) => {
            let payload = {};
            const epiBlockDataObj = action.epiBlockData;

            let epiBlockData = {
                blockId: epiBlockDataObj.contentLink.id,
                genericWizardAutomaticBlock: epiBlockDataObj.genericWizardAutomaticBlock.value,
                genericWizardManualBlock: epiBlockDataObj.genericWizardManualBlock.value,
                routerList: epiBlockDataObj.routerList.expandedValue,
                automaticInitializationPage: {
                    title: epiBlockDataObj.initializationPageTitle.value,
                    subTitle: epiBlockDataObj.initializationPageSubTitle.value,
                    attentionText: epiBlockDataObj.initializationPageAttentionText.value,
                    buttonText: epiBlockDataObj.initializationPageButtonText.value,
                },
                loadingPage: {
                    imageLoader: epiBlockDataObj.imageLoader.value?.url,
                    routerInitializationTime: epiBlockDataObj.routerInitializationTime.value,
                },
                manualInitializationPage: {
                    image:  epiBlockDataObj.manualInitializationPageIcon.value?.url,
                    title: epiBlockDataObj.manualInitializationPageTitle.value,
                    subTitle: epiBlockDataObj.manualInitializationPageSubTitle.value,
                    buttonText: epiBlockDataObj.manualInitializationPageButtonText.value,
                },
            };
            payload.page = action.page;
            payload.epiBlockData = epiBlockData;
            return { payload: payload };
        },
    },
    goToPage: (state, action) => {
        state.page = action.payload.page;
        state.messageType = action.payload.type ?? '';
        window.scrollTo(0, 0);
    },
    setSubscriber: (state, action) => {
        state.selectedSubscriber = action.payload;
    },
    setRouter: (state, action) => {
        if(action.payload){
            state.router.image = action.payload.imageProduct?.value?.url;
        }
    },
  },
  extraReducers: {
  },
});

export const {
    resetBlock,
    initBlock,
    goToPage,
    setSubscriber,
    setRouter
} = speedTestAndDisconnectionsWizardBlockSlice.actions;

export default speedTestAndDisconnectionsWizardBlockSlice.reducer;
